import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHashtag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHashtag"><Path fillRule="evenodd" clipRule="evenodd" d="M9.5848 3.09566L9.11155 6.99996H16.1006L16.5957 2.91516L18.0848 3.09566L17.6116 6.99996H21V8.49996H17.4297L16.5812 15.5H21V17H16.3994L15.9043 21.0848L14.4152 20.9043L14.8884 17H7.89943L7.4043 21.0848L5.9152 20.9043L6.38845 17H3V15.5H6.57027L7.41875 8.49996H3V6.99996H7.60057L8.0957 2.91516L9.5848 3.09566ZM8.92973 8.49996L8.08125 15.5H15.0703L15.9188 8.49996H8.92973Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHashtag;
